import {
  Button,
  message,

  Popconfirm,
  Popover,
  Space,
  Tag,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { SearchColumn } from "../../Components/TableSettings/TableSettings";
import {
  TeamOutlined,
  CloseOutlined,
  CheckOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
// import { useNavigate } from "react-router-dom";
import * as actions from "../../store/actions/action";
import { connect } from "react-redux";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import styles from "./Learners.module.css";
import api from "../../api/api";
import DataTable from "../../Components/DataTable/DataTable";
import StatusSetter from "../../util/StatusSetter";
import TableExportDropdown from "../../Components/TableExportDropdown/TableExportDropdown";
import { PageHeader } from "@ant-design/pro-components";
dayjs.extend(relativeTime);
const Learners = ({
  ErrorSetter,
  ClearError,
  LoadingSetter,
  ClearLoading,
  token,
  loading,
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  // const navigate = useNavigate();
  const [data, setData] = useState([]);
  const AuthHeader = { Authorization: "Token " + token };

  const fetchData = () => {
    LoadingSetter();

    api
      .get("/students", {
        headers: { ...AuthHeader },
        params: { status: "RE" },
      })
      .then((res) => {
        setData(res.data);
        ClearLoading();
      })
      .catch((err) => {
        ErrorSetter(
          "دریافت اطلاعات با مشکل مواجه شد، لطفا صفحه را ریفرش کنید."
        );
        ClearLoading();
      });
  };
  useEffect(() => {
    fetchData();
  }, []);

  const MoveToRequests = (record) => {
    SetStatus(
      record,
      "TE",
      "کاربر به لیست درخواست‌ها منتقل شد.",
      RemoveData(record)
    );
  };
  const Search = new SearchColumn(
    searchText,
    setSearchText,
    searchedColumn,
    setSearchedColumn,
    searchInput
  );

  //Update Data
  // const UpdateStatus = (record) => {
  //   let status = record.status;
  //   switch (record.status) {
  //     case 'NC':
  //       status = 'FC';
  //       break;
  //     case 'FC':
  //       status = 'SC';
  //       break;
  //     default:
  //       status = status;
  //       break;
  //   }
  //     LoadingSetter()
  //       const onSuccessFunction = ()=>{
  //         const newDataSource = [...data];
  //         newDataSource[newDataSource.indexOf(record)].status = status;
  //         newDataSource[newDataSource.indexOf(record)].last_update = dayjs().toISOString();
  //         setData(newDataSource);

  //       }
  //       SetStatus(record , status , 'وضعیت با موفقیت تغییر کرد.',onSuccessFunction)

  // };
  //Buttons OnClick Functions
  const SetStatus = (record, status, successMessage, onSuccessFunction) => {
    api
      .patch(
        "/student/" + record.id,
        { status },
        { headers: { ...AuthHeader } }
      )
      .then(() => {
        message.success(successMessage);
        ClearLoading();
        if (onSuccessFunction) {
          onSuccessFunction();
        }
      })
      .catch(() => {
        ClearLoading();
        ErrorSetter("مشکلی در تغییر وضعیت پیش آمده.");
      });
  };

  const RemoveData = (record) => {
    const newDataSource = [...data];
    const final = newDataSource.filter((dataEl) => {
      return newDataSource.indexOf(dataEl) !== newDataSource.indexOf(record);
    });
    setData(final);
  };
  const DeleteRequest = (record) => {
    LoadingSetter();
    SetStatus(record, "DE", "درخواست با موفقیت حذف شد.", () => {
      RemoveData(record);
    });
  };
  //Table Date

  const StatusFilter = [
    {
      text: "ثبت نام شده",
      value: "RE",
    },
  ];

  const checkTrackTimeHasCome = (record) => {
    const LastUpdate = record.last_update;
    const timeHasCome = dayjs(LastUpdate).fromNow();
    if (
      (((+timeHasCome.split(" ")[0] >= 3 && timeHasCome.includes("روز")) ||
        timeHasCome.includes("ماه") ||
        timeHasCome.includes("سال")) &&
        record.status === "NC" &&
        timeHasCome.includes("پیش")) ||
      (((+timeHasCome.split(" ")[0] >= 14 && timeHasCome.includes("روز")) ||
        timeHasCome.includes("ماه") ||
        timeHasCome.includes("سال")) &&
        record.status === "FC" &&
        timeHasCome.includes("پیش"))
    ) {
      return true;
    } else {
      return false;
    }
  };
  const last_placement_test = (record) => {
    const last_placement_test_value =
      record.placement_tests[record.placement_tests.length - 1];
    return last_placement_test_value;
  };
  const columns = [
    {
      title: "نام",
      dataIndex: "first_name",
      key: "first_name",
      ...Search.getColumnSearchProps("first_name"),
    },
    {
      title: "نام خانوادگی",
      dataIndex: "last_name",
      key: "last_name",
      ...Search.getColumnSearchProps("last_name"),
    },
    {
      title: "شماره موبایل",
      dataIndex: "phone_number",
      key: "phone_number",
      ...Search.getColumnSearchProps("phone_number"),
    },
    {
      title: "شهر محل سکونت",
      dataIndex: "city_live",
      key: "city_live",
      ...Search.getColumnSearchProps("city_live"),

      // sorter: (a, b) => a.address.length - b.address.length,
      // sortDirections: ['descend', 'ascend'],
    },
    {
      title: "دلیل یادگیری زبان",
      dataIndex: "aim_to_learn",
      key: "aim_to_learn",
      ...Search.getColumnSearchProps("aim_to_learn"),
    },
    {
      title: "شغل",
      dataIndex: "job",
      key: "job",
      width: "7%",
      // ...LongColumn,
      ...Search.getColumnSearchProps("job"),
    },
    {
      title: "تاریخ تعیین سطح",
      key: "test_date",
      width: "12%",
      sorter: (a, b) => {
        const aLastDate = a.test_date
          ? a.test_date[a.test_date.length - 1]
          : null;
        const bLastDate = b.test_date
          ? b.test_date[b.test_date.length - 1]
          : null;
        const MakeDateToNum = (date) => {
          return +date.split(" ")[0].split("-").join("");
        };
        const MakeClockToNum = (clock) => {
          return +clock.split(" ")[1].split(":").join("");
        };
        if (aLastDate && bLastDate) {
          const aDateNum = MakeDateToNum(aLastDate);
          const bDateNum = MakeDateToNum(bLastDate);
          const aClockNum = MakeClockToNum(aLastDate);
          const bClockNum = MakeClockToNum(bLastDate);
          if (aDateNum === bDateNum) {
            return aClockNum - bClockNum;
          }
          return MakeDateToNum(aLastDate) - MakeDateToNum(bLastDate);
        }
        if (aLastDate && !bLastDate) {
          return 1;
        } else {
          return -1;
        }
      },
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => {
        const last_placement_test_value = last_placement_test(record);
        const LastDate = last_placement_test_value.active_due_date;
        const JalaliLastDate =  last_placement_test_value.jactive_due_date;

        const timeHasCome = dayjs(LastDate).fromNow();
        let content = null;
        let status = checkTrackTimeHasCome(record) ? "volcano" : "default";

        const DateTextElement = (
          <div>
            <Tag color={status}>
              <div>{timeHasCome} </div>
              <div>
                <b>{JalaliLastDate}</b>
              </div>
            </Tag>
          </div>
        );

        content = DateTextElement;

        const dates = last_placement_test(record)
          ? last_placement_test(record).jdue_dates.map((el, index) => {
              const IsLastElement =
                index === last_placement_test(record).jdue_dates.length - 1;
              return (
                <div>
                  <div
                    className={[
                      styles.DateItem,
                      IsLastElement ? styles.DateItemActive : null,
                    ].join(" ")}
                  >
                    <div className={styles.DateItemIcon}>
                      {IsLastElement ? <CheckOutlined /> : <CloseOutlined />}
                    </div>{" "}
                    {el}
                  </div>
                  {!IsLastElement ? <div className={styles.Line} /> : null}
                </div>
              );
            })
          : "تاریخی وجود ندارد.";
        return (
          <Space className={styles.DateCellContainer}>
            {content}
            <Popover content={dates} title="تاریخ‌ها">
              <Button type="link">بیشتر</Button>
            </Popover>
          </Space>
        );
      },
    },
    // {
    //   title: "نمره",
    //   key: "score",
    //   width: "8%",
    //   filters: ScoreFilter,
    //   onFilter: (value, record) => {
    //     return last_placement_test(record).score === value;
    //   },

    //   filterSearch: true,
    //   render: (text, record, index) => {

    //     return <Tag color="success">{last_placement_test(record).score}</Tag>;
    //   },
    // },
    {
      title: "کیفیت لید",
      dataIndex: "is_organic",
      key: "is_organic",
      width: "8%",
      filters: [
        { value: "ORGANIC", text: "ارگانیک" },
        { value: "NON-ORGANIC", text: "غیر ارگانیک" },
      ],
      onFilter: (value, record) => record.is_organic === value,
      render: (text, record, index) => {
        if (text === "ORGANIC") {
          return <Tag color="blue">ارگانیک</Tag>;
        }
        if (text === "NON-ORGANIC") {
          return <Tag color="red">ارگانیک</Tag>;
        }
      },
    },
    {
      title: "وضعیت",
      dataIndex: "status",
      key: "status",
      width: "8%",
      filters: StatusFilter,
      onFilter: (value, record) => record.status.includes(value),
      filterSearch: true,
      render: (text, record, index) => {
        return <Tag color="success">{StatusSetter(text)}</Tag>;
      },
    },
    {
      title: "عملیات",
      align: "center",
      width: "9%",

      render: (text, record, index) => {
        const type = checkTrackTimeHasCome(record) ? "primary" : "dashed";
        return (
          <Popover
            content={
              <div>
                <Popconfirm
                  okText="بله"
                  cancelText="خیر"
                  okButtonProps={{ type: "primary" }}
                  cancelButtonProps={{ type: "dashed" }}
                  title="آیا می‌خواهید زبان آموز به درخواست‌ها منتقل شود؟"
                  placement="top"
                  onConfirm={() => {
                    MoveToRequests(record);
                  }}
                >
                  <Button style={{ marginBottom: "0.5rem" }} block type={type}>
                    انتقال به درخواست‌ها
                  </Button>
                </Popconfirm>
                {/* <Popconfirm
                  okText="بله"
                  cancelText="خیر"
                  okButtonProps={{ danger: true, type: "primary" }}
                  cancelButtonProps={{ type: "dashed" }}
                  title="آیا زبان آموزش از ثبت نام انصراف داد؟"
                  placement="top"
                  onConfirm={() => {
                    DeleteRequest(record);
                  }}
                >
                  <Button block danger type={type}>
                    انصراف زبان آموز
                  </Button>
                </Popconfirm> */}
              </div>
            }
          >
            <Button type="link">بیشتر</Button>
          </Popover>
        );
      },
    },
    // {
    //   title: "عملیات",
    //   align: "center",
    //   children: [
    //     {
    //       title: "ثبت نام",
    //       align: "center",
    //       width: "9%",
    //       render: (text, record, index) => {
    //         const type = checkTrackTimeHasCome(record) ? "primary" : "";

    //         return (
    //           <Button block type={type}>
    //             ثبت نام
    //           </Button>
    //         );
    //       },
    //     },
    //     {
    //       title: "پیگیری مجدد",
    //       align: "center",
    //       width: "9%",

    //       render: (text, record, index) => {
    //         const type = checkTrackTimeHasCome(record) ? "primary" : "dashed";

    //         return (
    //           <>
    //           {checkTrackTimeHasCome(record) ? <Button block type={type} onClick={()=>{
    //           UpdateStatus(record)
    //         }}>
    //           پیگیری مجدد
    //         </Button> : <Popconfirm
    //           okText="بله"
    //           cancelText="خیر"
    //           okButtonProps={{ type: "primary" }}
    //           cancelButtonProps={{ type: "dashed" }}
    //           title="هنوز زمان پیگیری نرسیده، آیا از تغییر وضعیت مطمئن هستید؟"
    //           placement="top"
    //           onConfirm={() => {
    //             UpdateStatus(record)
    //           }}>
    //             <Button block type={type}>
    //           پیگیری مجدد
    //         </Button>
    //             </Popconfirm>}
    //           </>
    //         );
    //       },
    //     },
    //     {
    //       title: "انصراف",
    //       align: "center",
    //       width: "9%",

    //       render: (text, record, index) => {
    //         const type = checkTrackTimeHasCome(record) ? "primary" : "dashed";
    //         return (
    //           <Popconfirm
    //             okText="بله"
    //             cancelText="خیر"
    //             okButtonProps={{ danger: true, type: "primary" }}
    //             cancelButtonProps={{ type: "dashed" }}
    //             title="آیا زبان آموزش از ثبت نام انصراف داد؟"
    //             placement="top"
    //             onConfirm={() => {
    //               DeleteRequest(record);
    //             }}
    //           >
    //             <Button block danger type={type}>
    //               انصراف
    //             </Button>
    //           </Popconfirm>
    //         );
    //       },
    //     },
    //   ],
    // },
  ];

  return (
    <div>
      <PageHeader
        className="site-page-header"
        title="زبان آموزان"
        extra={
          <Space>
            <Button
              icon={<ReloadOutlined />}
              disabled={loading}
              type="default"
              onClick={() => {
                fetchData();
              }}
            >
              بروزرسانی
            </Button>
            {/* <TableExportDropdown
              disabled={loading}
              name="زبان آموزان"
              data={data}
              columns={columns}
            /> */}
            {/* <Statistic title="تعداد درخواست‌ها" value={112}  /> */}
          </Space>
        }
        avatar={{ icon: <TeamOutlined /> }}
        subTitle="| ثبت شده در سیستم"
      />
      <DataTable
        loading={loading}
        scroll={{ x: "calc(700px + 50%)" }}
        columns={columns}
        dataSource={data}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    token: state.token,
    loading: state.loading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ErrorSetter: (error, errorType) =>
      dispatch(actions.ErrorSetter(error, errorType)),
    ClearError: () => dispatch(actions.ClearError()),
    LoadingSetter: (error, errorType) => dispatch(actions.LoadingSetter()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Learners);
